import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import { SingleEntityState } from '../store/singleEntityState';

const initialState: SingleEntityState = {
  defaultClipConfiguration: null,
};

export function singleEntityReducer(state: SingleEntityState = initialState, action: AllActions): SingleEntityState {
  switch (action.type) {
    case InternalActionTypes.DefaultClipConfigurationLoaded:
      return {
        ...state,
        defaultClipConfiguration: action.result.result,
      };
    default:
      return state;
  }
}
